import React from 'react';
import { Header, Footer } from '../components/common';
import '../components/common/PageLayout.css';

const TermsOfService = () => {
  return (
    <>
      <div className="hero-gradient-wrap">
        <Header ctaText="Join Community" ctaPath="#courses" />
        <section className="page-hero">
          <h1>Terms of Service</h1>
          <p>These Terms of Service govern your access to and use of the InfinySkills website and services.</p>
        </section>
      </div>
      <main className="page-layout-main">
        <section className="page-section">
          <h2>1. Acceptance of Terms</h2>
          <p>
            This website, InfinySkills, is owned and operated by InfinySkills. These Terms of Service
            (“Agreement”) govern your access to and use of the website and its services. By accessing or
            using this website, you acknowledge that you have read, understood, and agree to be bound by
            these terms and conditions. If you do not agree with any part of these terms, you must not
            access or use the website.
          </p>
          <p>
            If you are dissatisfied with any of the terms, conditions, policies, or practices of
            InfinySkills, your sole and exclusive remedy is to discontinue using the website. InfinySkills
            reserves the right to modify or update this Agreement at any time by posting revised terms on
            this page. Continued use of the website after such updates constitutes your acceptance of the
            revised terms. Users are encouraged to review this page periodically to stay informed of any
            changes.
          </p>
        </section>

        <section className="page-section">
          <h2>2. Our Services</h2>
          <p>
            All services, content, and resources provided through the InfinySkills website are offered on
            an “AS IS” and “AS AVAILABLE” basis. InfinySkills reserves the exclusive right to modify,
            suspend, discontinue, or update any part of the website or its services at any time without
            prior notice and without liability to users. This may include updating course materials,
            removing content, or altering features available on the platform.
          </p>
          <p>
            InfinySkills shall not be responsible for any delays, interruptions, inaccuracies, deletion of
            data, or failure to store any information provided by users. The platform does not guarantee
            uninterrupted or error-free access to its services.
          </p>
        </section>

        <section className="page-section">
          <h2>3. User Responsibilities and Registration</h2>
          <p>
            In order to access certain services or features of the platform, users may be required to
            create an account. By registering on InfinySkills, you agree to provide accurate, current, and
            complete information as requested during the registration process. You must be at least
            thirteen (13) years of age to use this website.
          </p>
          <p>
            You are responsible for maintaining the confidentiality of your account credentials and for
            all activities that occur under your account. InfinySkills reserves the right to suspend or
            terminate accounts that provide false information or violate these terms.
          </p>
        </section>

        <section className="page-section">
          <h2>4. Privacy Policy</h2>
          <p>
            Any personal information collected through the website during registration or use of services
            will be handled in accordance with the InfinySkills Privacy Policy. By using the platform, you
            consent to the collection, storage, and use of your information as described in that policy.
          </p>
        </section>

        <section className="page-section">
          <h2>5. User Conduct</h2>
          <p>
            Users are solely responsible for any information, content, or material they provide on the
            website. By using this website, you agree not to upload, publish, or distribute any content
            that is unlawful, harmful, abusive, threatening, defamatory, obscene, or otherwise
            objectionable. Users must not engage in activities that disrupt or interfere with the proper
            functioning of the platform, including introducing malicious software, attempting unauthorised
            access, or misrepresenting their identity.
          </p>
          <p>
            You also agree not to collect or harvest personal information of other users without
            permission, and not to use the platform for unauthorised advertising, spam, chain letters, or
            other forms of unsolicited communication. Any content or activity that violates applicable
            local, national, or international laws is strictly prohibited.
          </p>
          <p>
            Course materials, training content, and resources provided by InfinySkills are intended solely
            for personal learning purposes through the platform. Users may not reproduce, distribute,
            share, copy, record, or transmit any course content in any form without prior written
            permission from InfinySkills.
          </p>
        </section>

        <section className="page-section">
          <h2>6. Submission of Content</h2>
          <p>
            By submitting any content to InfinySkills, including feedback, comments, or other materials,
            you grant InfinySkills a worldwide, royalty-free, perpetual, and non-exclusive license to use,
            display, reproduce, modify, adapt, publish, distribute, and create derivative works from such
            content. This license applies across all media formats and technologies currently known or
            developed in the future.
          </p>
          <p>
            You represent and warrant that you have the legal rights necessary to provide such content and
            grant the permissions described above. InfinySkills reserves the right, at its sole
            discretion, to remove or refuse to publish any content that violates these terms or is deemed
            inappropriate.
          </p>
        </section>

        <section className="page-section">
          <h2>7. Third-Party Services</h2>
          <p>
            The website may include references, advertisements, or links to products and services provided
            by third parties. Any representations made regarding such products or services are governed by
            the policies and terms of those third parties. InfinySkills shall not be responsible for any
            interactions, transactions, or agreements between users and third-party providers.
          </p>
        </section>

        <section className="page-section">
          <h2>8. Indemnification</h2>
          <p>
            You agree to indemnify and hold harmless InfinySkills, its affiliates, partners, employees,
            and representatives from any claims, damages, liabilities, costs, or expenses arising from
            your use of the website, your violation of these Terms of Service, or your infringement of any
            rights belonging to another individual or entity.
          </p>
        </section>

        <section className="page-section">
          <h2>9. Disclaimer of Warranties</h2>
          <p>
            You understand and agree that your use of the InfinySkills website and services is at your own
            risk. The services are provided on an “AS IS” and “AS AVAILABLE” basis without warranties of
            any kind, whether express or implied. InfinySkills expressly disclaims all warranties,
            including but not limited to warranties of merchantability, fitness for a particular purpose,
            and non-infringement.
          </p>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default TermsOfService;

